import {FiSearch} from "react-icons/fi";

interface FilterPropsI {
    className?: string;
    inputClassName?: string;
    onChange: (val: string)=>void;
    placeholder?: string;
    value: string;
}

const BaseFilter = ({ className, inputClassName, onChange, placeholder, value } :FilterPropsI)=>{
    return (
        <div className={`form__input--group ${className}`}>
            <div className="prepend__input">
                <FiSearch />
            </div>
            <input
                value={value}
                type="text"
                placeholder={placeholder ? placeholder : 'Filter'}
                className={`form__input prepend ${inputClassName}`}
                onChange={e=>onChange(e.target.value)}
            />
        </div>
    )
}
export default BaseFilter;